import React from 'react';
import './ValidationModal.css'; // Reutilizando os estilos

const ConfirmationModal = ({ 
    isOpen, 
    title = "Confirmação", 
    message, 
    confirmText = "Confirmar", 
    cancelText = "Cancelar", 
    onConfirm, 
    onCancel,
    type = "warning" // warning, success, error, info
}) => {
    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'success': return '✅';
            case 'error': return '❌';
            case 'info': return 'ℹ️';
            case 'warning':
            default: return '⚠️';
        }
    };

    const getHeaderClass = () => {
        switch (type) {
            case 'success': return 'modal-header-success';
            case 'error': return 'modal-header-error';
            case 'info': return 'modal-header-info';
            case 'warning':
            default: return 'modal-header-warning';
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onCancel();
        }
    };

    return (
        <div className="validation-modal-backdrop" onClick={handleBackdropClick}>
            <div className="validation-modal confirmation-modal">
                <div className={`validation-modal-header ${getHeaderClass()}`}>
                    <h3>{getIcon()} {title}</h3>
                    <button className="validation-modal-close" onClick={onCancel}>×</button>
                </div>
                
                <div className="validation-modal-content">
                    <p className="validation-modal-description">
                        {message}
                    </p>
                </div>
                
                <div className="validation-modal-footer">
                    {cancelText && (
                        <button 
                            className="validation-modal-button secondary" 
                            onClick={onCancel}
                        >
                            {cancelText}
                        </button>
                    )}
                    <button 
                        className="validation-modal-button primary" 
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
